import { afterNextRender, Directive, ElementRef, inject } from '@angular/core';
import { MatFabButton } from '@angular/material/button';
import { MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS } from '@angular/material/progress-spinner';

const DEFAULT_DIAMETER = 20;
const LARGE_DIAMETER = 24;

@Directive({
  selector: 'mat-progress-spinner[glxyButtonProgressIndicator]',
  providers: [
    {
      provide: MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS,
      useFactory: () => {
        const fab = inject(MatFabButton, { optional: true, skipSelf: true });
        return { diameter: fab ? LARGE_DIAMETER : DEFAULT_DIAMETER };
      },
    },
  ],
})
export class GlxyButtonProgressIndicatorDirective {
  constructor() {
    const el = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;

    afterNextRender(() => {
      const button = el.closest('.glxy-button-show-progress-host');
      if (button && el.parentElement !== button) {
        button.appendChild(el);
      }
    });
  }
}
